"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }



 const openFileInNewWindow = (
  requestUrl,
  onFallback,
) => {
  const reservedWindow = window.open('', '_blank')
  let request
  try {
    request = requestUrl()
  } catch (_) {
    _optionalChain([reservedWindow, 'optionalAccess', _2 => _2.close, 'call', _3 => _3()])
    onFallback({ status: 'error' })
    return
  }
  request
    .then(url => {
      if (!url) {
        _optionalChain([reservedWindow, 'optionalAccess', _4 => _4.close, 'call', _5 => _5()])
        onFallback({ status: 'error' })
        return
      }
      if (reservedWindow) {
        reservedWindow.location.href = url
      } else {
        onFallback({ status: 'ready', url })
      }
    })
    .catch(() => {
      _optionalChain([reservedWindow, 'optionalAccess', _6 => _6.close, 'call', _7 => _7()])
      onFallback({ status: 'error' })
    })
}; exports.openFileInNewWindow = openFileInNewWindow
